import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 获取角色列表
 * @param params
 */
export const getGroupListApi = (params:object = {}) => $http.get(`/channel/get_group_list`, params)

/**
 * 获取用户列表
 * @param params
 * group_id：角色分组ID
 */
export const getUserListApi = (params:object = {}) => $http.get(`/channel/get_user_list`, params)

/**
 * 获取蛋叔员工，以组织架构方式展示
 * @param params
 */
export const getDepartmentUserListApi = () => $http.get('/channel/contract_user_list')

/**
 * 更新已绑定手机号
 * @param params
 */
export const updateBindPhone = (phone:string, code:string) => $http.post('/cake_api/up_info', { phone, code })

// 获取绑定手机号修改记录
export const getBindPhoneLogApi = () => $http.get('/cake_api/getPhoneInfo')

// 获取评论列表
export const getCommentListApi = (params:object = {}) => $http.get('/admin/user/get_user_comment_list', params)

// 批量显示、隐藏评论
export const batchShowCommentApi = (params:object = {}) => $http.post('/admin/user/oper_user_comment', params)

// 获取评论详情数据
export const getCommentDetailApi = (params:object = {}) => $http.get('/admin/user/get_user_comment_info', params)

// 回复评论
export const replyCommentApi = (params:object = {}) => $http.post('/admin/user/replay_comment', params)

// 获取用户余额列表可导出
export const getUserMoneyListApi = (params:object = {}) => $http.get('/admin/user/get_user_money_list', params)

// 获取用户列表
export const getUsersListApi = (params:object = {}) => $http.get('/admin/user/get_user_list', params)

// 获取用户详情
export const getUserInfoApi = (params:object = {}) => $http.get('/admin/user/get_user_info', params)

// 获取用户消费记录
export const getUserConsumeApi = (params:object = {}) => $http.get('/admin/user/get_user_consume', params)

// 修改密码
export const changePasswordApi = (params:object = {}) => $http.post('/opsapi/change_password', params)

//获取用户卡包列表
export const getMoneyCardListApi = (params:object = {}) => $http.get('/opsapi/get_moneycard_list', params)

// 获取用户余额消费列表
export const getMoneylistApi = (params:object = {}) => $http.get('/opsapi/money_list', params)

// 修改用户余额
export const adjustCardBalanceApi = (params:object = {}) => $http.post('/opsapi/adjustCardBalanceApi', params)

//用户迁移
export const userTransformNewApi = (params:object = {}) => $http.post('/opsapi/user_transform_new', params)

// 获取用户礼券列表
export const getUserCouponListApi = (params:object = {}) => $http.get('/opsapi/user_coupon_log', params)

// 帮订
export const butlerAddApi = (params:object = {}) => $http.get('/opsapi/butler_add', params)

// 获取城市和区县的编码    
export const getAddressCodeApi = (params:object = {}) => $http.get('/dsapi/addr/citycode', {...params,urlPrefix: '/ci_api'})

// 保存用户地址
export const serveAddrApi = (params:object = {}) => $http.get('/opsapi/serve_addr', params)

// 生成链接
export const saveCheckoutH5Api = (params:object = {}) => $http.post('/opsapi/save_checkout_h5', params)

// 发送模板消息
export const sendTemplateMessageApi = (params:object = {}) => $http.post('/dsapi/order/wx_member', {...params,urlPrefix: '/ci_api'})

// 操作用户状态
export const updateUserStatusApi = (params:object = {}) => $http.post('/admin/user/oper_user_status', params)

// 获取商品信息
export const serveProductApi = (params:object = {}) => $http.get('/dsapi/product/serve_product', {...params,urlPrefix: '/ci_api'})

// 获取配归信息
export const checkoutH5Api = (params:object = {}) => $http.get('/dsapi/order/checkout_h5', {...params,urlPrefix: '/ci_api'})

/**
 * 获取黄牛用户列表
 * @param uid           用户id
 * @param uname         用户名
 * @param phone         手机号
 * @param channel       持卡渠道
 * @param record_type   标记类型：0-疑似黄牛，1-黄牛，2-白名单，3-继续观察
 */
export const getScalperListApi = (params: object) => $http.get('/sys/admin/getBlacklist', params)

/**
 * 变更用户黄牛记录状态
 * @param id            用户ID
 * @param record_type   标记类型：0-疑似黄牛，1-黄牛，2-白名单，3-继续观察
 */
export const changeScalperTypeApi = (id: number | string, record_type: number | string) => $http.get('/sys/admin/operYellowUser', { id, record_type })

/**
 * 标记为真黄牛（禁用用户）
 * @param uid       用户ID
 */
export const markRealScalperApi = (uid: number | string) => $http.post('/sys/admin/operBlackUser', { uid })